<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Grafmonumenten"
      intro="Bij een overlijden begeleiden we u ook bij de keuze van een grafmonument. Hier vindt u alvast een impressie uit ons assortiment."
    />

    <!-- Grafmonumenten gallery -->
    <v-row justify="center">
      <v-col
        class="center mb-8"
        cols="12"
        lg="8"
      >
        <v-row>
          <v-col
            v-for="column in 3"
            cols="12"
            md="4"
            :key="column"
style="padding-left: 6px; padding-right: 5px;"
          >
            <v-img
              v-for="n in [[1, 8, 7], [2, 5, 4], [3, 6, 9]][column - 1]"
              contain
              :key="n"
              max-height="554px"
              max-width="350px"
              :src="require(`@/assets/images/Grafmonumenten/Grafmonument ${n}.png`)"
              style="margin-bottom: 11px;"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import PageHero from '@/components/PageHero.vue'

export default {
  name: 'GrafmonumentenComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin
  ],
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.keuzesUitvaart = true
  },
  beforeUnmount () {
    this.$store.state.headers.keuzesUitvaart = false
  }
}
</script>

<style scoped>
.graf-empty {
  font-size: 16px;
  color: #999;
  padding: 48px 0;
}
</style>
